import './index.less'
const EmptyPlaceholder = ({ text, className = '' }) => {
  return (
    <div className={`empty-placeholder ${className || ''}`}>
      <div className="img"></div>
      <div>
        <span>{text}</span>
      </div>
    </div>
  )
}

export default EmptyPlaceholder
